import { createIconComponent } from '../../factory/create-icon-component';
export const FullScreenInvertedIcon = createIconComponent(
  'FullScreenInvertedIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.99994 15.9999H2.09801C3.86976 15.9999 4.75563 15.9999 5.45923 16.2756C6.49678 16.6822 7.31771 17.5031 7.72425 18.5407C7.99994 19.2443 7.99994 20.1301 7.99994 21.9019M15.9999 21.9999V21.9019C15.9999 20.1301 15.9999 19.2443 16.2756 18.5407C16.6822 17.5031 17.5031 16.6822 18.5406 16.2756C19.2443 15.9999 20.1301 15.9999 21.9019 15.9999M21.9999 7.9018H21.9019C20.1301 7.9018 19.2443 7.9018 18.5406 7.62611C17.5031 7.21957 16.6822 6.39864 16.2756 5.36109C15.9999 4.65749 15.9999 3.77162 15.9999 1.99988M7.90228 1.99995V2.09802C7.90228 3.86976 7.90228 4.75564 7.62659 5.45924C7.22005 6.49679 6.39912 7.31771 5.36157 7.72426C4.65797 7.99995 3.7721 7.99995 2.00036 7.99995"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
